//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";

const PlainTile = ({ description1, description2, description3, name, link, icon, messages, className, attributeOptions, spinner }) => {
    let history = useHistory();

    const msgs = (messages) => {
        messages.map((item, index) => {
            return (
                item.msg.level === "warning" ?
                    <span key={index} className="badge badge-warning">{item.msg.message}<br /></span>
                    :
                    item.msg.level === "success" ?
                        <span key={index} className="badge badge-success">{item.msg.message}<br /></span>
                        :
                        <span key={index}>{item.msg.message}<br /></span>
            );
        })
    }

    const handleClick = (link, e) => {
        e.preventDefault();
        history.push(link);
    }

    const setName = (name) => {
        return { __html: name };
    }

    return (
        <div className={`casa-dashboard-item au-card au-card--shadow ${className}`} onClick={(e) => handleClick(link, e)} {...attributeOptions}>
            <div className={`icon icon-profile i ${icon}`}></div>
            <div className="tilebody">
                <h2><a href={link}><strong dangerouslySetInnerHTML={setName(name)}></strong><br /></a></h2>
                {!spinner && description1 !== "" ? <div>{description1}<br /></div> : ""}
                {!spinner && description2 !== "" ? <div>{description2}<br /></div> : ""}
                {!spinner && description3 !== "" ? <div>{description3}<br /></div> : ""}
                {!spinner && msgs(messages)}
            </div>
        </div>  
    )

}

PlainTile.propTypes = {
    name: PropTypes.string.isRequired,
    description1: PropTypes.string,
    description2: PropTypes.string,
    description3: PropTypes.string,
    link: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    messages: PropTypes.array.isRequired,
    className: PropTypes.string,
    attributeOptions: PropTypes.object,
    spinner: PropTypes.bool.isRequired
};

export default PlainTile;
